import React from 'react'

import { SvgIconProps, SvgIcon } from '@mui/material'

export interface IconProps extends SvgIconProps {
  name: Icons
}

type Icons =
  | 'layout-map'
  | 'layout-table'
  | 'sort'
  | 'filter-date'
  | 'search'
  | 'arrow-down'
  | 'close'
  | 'more-details'
  | 'checkbox'
  | 'info'
  | 'success'
  | 'profile-avatar'
  | 'check'
  | 'logo'
  | 'timer'
  | 'copy'
  | 'facebook'
  | 'telegram'
  | 'instagram'
  | 'twitter'
  | 'whats-app'
  | 'messenger'
  | 'log-out'
  | 'signIn'

export const Icon = ({ name, ...props }: IconProps) => {
  return (
    <SvgIcon {...props}>
      <svg>
        <use href={`#${name}`} />
      </svg>
    </SvgIcon>
  )
}
